import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Footer from "../components/Footer";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import HistoryIcon from "@mui/icons-material/History";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import SchoolIcon from "@mui/icons-material/School";
import AllInclusiveIcon from "@mui/icons-material/AllInclusive";
import RadarIcon from "@mui/icons-material/Radar";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import SelfImprovementIcon from "@mui/icons-material/SelfImprovement";
import SportsBasketballIcon from "@mui/icons-material/SportsBasketball";
import LibraryMusicIcon from "@mui/icons-material/LibraryMusic";
import ClassIcon from "@mui/icons-material/Class";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import HistoryEduIcon from "@mui/icons-material/HistoryEdu";
import FavoriteIcon from "@mui/icons-material/Favorite";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import Explore from "./Explore";
import VisitUs from "../components/VisitUs";

export default function Dashboard() {
  const [transition, setTransition] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [newsTranslate, setNewsTranslate] = useState(0);
  const [newsCount, setNewsCount] = useState(1);

  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const ref = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(-200, -200);
    setTimeout(() => setTransition(true), 500);
    setTimeout(() => {
      gsap.to(".loader", { opacity: 0, duration: 0.1 }).then(() => {
        setIsLoading(false);

        setTimeout(() => {
          setInterval(() => {
            gsap
              .to(".newsDot", {
                opacity: 0,
                scale: 6,
                duration: 0.5,
              })
              .then(() => {
                gsap.to(".newsDot", {
                  opacity: 1,
                  scale: 1,
                  duration: 0,
                });
              });
          }, 1000);
          gsap.to(".hero, .video, .overlay", {
            opacity: 1,
            duration: 0.1,
          });
          let newsItems = gsap.utils.toArray(".icard");

          newsItems.forEach((item, i) => {
            let hover = gsap.to(item, {
              scale: 1.025,
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
              duration: 0.3,
              paused: true,
              ease: "power2.inOut",
            });
            item.addEventListener("mouseenter", () => {
              hover.play();
            });
            item.addEventListener("mouseleave", () => {
              hover.reverse();
            });
          });
        }, 100);
      });
    }, 500);
  }, []);

  function newsLeft() {
    if (newsCount > 0) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate + 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate + 200);
      setNewsCount(newsCount - 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: "#000c66", navOpacity: 1 },
      });
    }
  }

  function newsRight() {
    if (newsCount < 2) {
      gsap.to(".newsSlider", {
        translateX: newsTranslate - 200,
        duration: 0.5,
      });
      setNewsTranslate(newsTranslate - 200);
      setNewsCount(newsCount + 1);
      dispatch({
        type: "NAV_COLOR",
        payload: { navColor: "#000c66", navOpacity: 1 },
      });
    }
  }

  function getContent() {
    if (isLoading) {
      return (
        <Lottie
          className="loader"
          style={{ height: "0" }}
          animationData={loading}
          loop={true}
        />
      );
    } else {
      return (
        <div className="main">
          <Sidebar />
          <div className="overlay"></div>
          <div
            style={{
              height: "75px",
              width: "75px",
              borderRadius: "40px",
              backgroundColor: "black",
              position: "fixed",
              right: 20,
              zIndex: 4,
              bottom: 20,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              opacity: 0,
            }}
            onClick={() => {
              window.scrollTo(0, 0);
            }}
            className="takemeup"
          >
            <ArrowUpwardIcon style={{ color: "white", fontSize: "40px" }} />
          </div>
          <video
            src={bg}
            type="video/mp4"
            autoPlay
            loop
            muted
            id="video"
            className="video"
          />{" "}
          <div
            className="herotitle"
            style={{
              marginTop: state.auth.isMobile ? "-90vh" : "-65vh",
              marginBottom: "50vh",
              textAlign: "center",
              height: "200px",
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontSize: state.auth.isMobile ? "40px" : "75px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              textShadow: "8px 8px 8px black",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            WELCOME TO SLV INTERNATIONAL SCHOOL
          </div>
          <div className="hero" style={{}}>
            <div
              style={{
                fontSize: state.auth.isMobile ? "30px" : "55px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color: "#880808",
                marginTop: "50px",
              }}
            >
              SLV INTERNATIONAL SCHOOL
            </div>
            <br />
            <br />
            <div
              style={{
                textAlign: "justify",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                marginBottom: "30px",
              }}
            >
              We develop Pre-10th students into unstoppable learners and leaders
              who are inspired to make an impact, determined to fulfill their
              potential, and driven to take control of their futures.
            </div>
            <div
              onClick={() => navigate("about_school")}
              style={{
                marginBottom: "100px",
                cursor: "pointer",
                textAlign: "justify",
                fontSize: state.auth.isMobile ? "20px" : "30px",
                fontWeight: "bold",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
                fontFamily: "Montserrat",
                textDecoration: "underline",
              }}
            >
              Learn more about SLV International School
            </div>
          </div>
          {/* <div className="growth">
            <div
              style={{
                marginTop: "-650px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  marginTop: "100px",
                  display: "flex",
                  width: "100%",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
                <div
                  style={{
                    height: "300px",
                    width: "70%",
                    backgroundColor: "white",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={() => newsLeft()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronLeftIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                  <div
                    onClick={() => newsRight()}
                    style={{
                      height: "40px",
                      width: "40px",
                      borderRadius: "10px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      zIndex: 3,
                    }}
                  >
                    <ChevronRightIcon
                      style={{ color: "white", fontSize: "40px" }}
                    />
                  </div>
                </div>
                <div
                  style={{
                    height: "500px",
                    width: "15%",
                    backgroundColor: "white",
                    zIndex: 3,
                  }}
                ></div>
              </div>
              <div
                className="newsSlider"
                style={{
                  marginTop: "-252px",
                  height: "5px",
                  width: "100%",
                  backgroundColor:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-around",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1995
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1996
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1997
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1998
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    1999
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginTop: "180px",
                  }}
                >
                  <div
                    className="newsDot"
                    style={{
                      height: "15px",
                      width: "15px",
                      borderRadius: "15px",
                      marginTop: "65px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      height: "25px",
                      width: "25px",
                      marginTop: "-20px",
                      borderRadius: "15px",
                      backgroundColor:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                    }}
                  ></div>
                  <div
                    style={{
                      textAlign :"justify",
                      fontSize: state.auth.isMobile ? "20px" : "30px",
                      fontWeight: "bold",
                      fontFamily: "Montserrat",
                    }}
                  >
                    2000
                  </div>
                  <div
                    style={{
                      textAlign :"justify",
                      width: "155px",
                      marginTop: "15px",
                      fontSize: "20px",
                      fontFamily: "Montserrat",
                    }}
                  >
                    SSLC Building was established at Our first building campus
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="aboutabout2" style={{ marginTop: "-300px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "30px" : "50px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.prtmaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Welcome To SLV International School
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "25px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  1. The location of a school has an enormous significance; our
                  school is far away from the noises and the pollution. The
                  ambience is calm, spacious with good amenities and utilities
                  in a visually appealing landscape. <br /> <br /> 2. The
                  backbone of any school’s infrastructure is the classroom. We
                  have adequate classrooms which are pleasant with modern
                  learning experience.
                  <br /> <br /> 3. Enriching young minds with value based
                  Education. We strive to offer true education that teaches and
                  imbibes universal values and morals, builds courage, instills
                  self-confidence, and fosters a sense of responsibility in the
                  children. <br /> <br />
                  4. A competent teacher plays a vital role in the growth of the
                  child. Our teachers are highly qualified, value-driven,
                  passionate and experienced. <br /> <br />
                  5. The events and activities are part of the curriculum which
                  aims at instilling discipline, ethics and values in students
                  that would help them to develop their personality to become
                  better citizens of the world.
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    margin: "30px 0px 10px 0px",
                  }}
                >
                  <Link
                    style={{
                      textDecoration: "none",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryButtonTextColor
                          : themeStyle.primaryButtonTextColor,
                    }}
                    to={"/about"}
                  >
                    <Button
                      style={{
                        padding: "30px",
                        border:
                          "2px " + state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor + " solid",
                        borderRadius: "45px",
                        height: "30px",
                        fontSize: "20px",
                        fontWeight: "bold",
                        color:
                          state.auth.theme == "dark"
                            ? themeStyleDark.primaryColor
                            : themeStyle.primaryColor,
                      }}
                    >
                      Read More
                    </Button>
                  </Link>
                </div>
              </Grid>

              <Grid item xs={12} md={5}>
                <div className="slider">
                  <div className="slides-container">
                    <div className="slides-inner">
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/vday.jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/krshna.jpeg")}
                        />
                      </div>
                      <div className="slide">
                        <img
                          style={{
                            width: "100%",
                            objectFit: "cover",
                            margin: "10px",
                            height: "100%",
                          }}
                          src={require("../img/pg2.jpg")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="controls">
                    <Button
                      className="button-carousel"
                      id="prevButton"
                      style={{
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Prev
                    </Button>

                    <Button
                      className="button-carousel"
                      id="nextButton"
                      style={{
                        marginLeft: "15px",
                        border: "2px solid " + themeStyle.primaryColor,
                        borderRadius: "25px",
                        height: "30px",
                        fontSize: "15px",
                        color: themeStyle.primaryColor,
                        fontWeight: "bold",
                        padding: "2px 10px 0px 10px",
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="aboutabout2" style={{ marginTop: "50px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} md={5}>
                <img
                  style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                  src={require("../img/chair.png")}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <div
                  style={{
                    fontSize: "32px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Chairman's Message
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  <b>
                    {" "}
                    "We cannot always build the future for our youth, but we can
                    build our youth for the future."{" "}
                  </b>{" "}
                  - Franklin D. Roosevelt <br />
                  <br /> It gives me an immense pleasure to welcome you to the
                  family of SLV group of Institutions. The above words by
                  Franklin D. Roosevelt perfectly describe our aim. Our aim is
                  to teach students to LEARN, not just STUDY. Hence, we strive
                  to travel beyond the boundaries of mere books. We have
                  realized that the future is abstract and unknown but the youth
                  In our hands are real and can be moulded. Our philosophy of
                  education has always been meeting the needs of the individual
                  child. Children acquire skills and knowledge easily if we make
                  the surrounding stimulating and purposeful. Education is a
                  complete process that leads to the attainment of the full
                  potential of the child. It makes a child a right thinker and a
                  good decision-maker.
                  <br />
                  <br />
                  Our focus is to develop our students as global citizens, with
                  tolerance, respect, and appreciation of diverse cultures and
                  religions for a lifetime learning experience. They should be
                  self-motivated, independent, confident decision makers to take
                  up leadership roles in the future. At our school, we provide
                  an environment and curriculum where children can explore and
                  develop every aspect of their lives. In other words, this
                  unique educational institution seeks to blend the beauty of
                  traditional cultural values and the latest in teaching aids
                  and methodology to optimize learning, open young minds and
                  empower young people to become global citizens, who stand tall
                  and live with courage and conviction, carving a niche for
                  themselves wherever they go.We opine that an ideal school
                  system should be characterized by flexibility which makes it
                  adaptable to changes. It should be a place....
                  <br /> <br /> - Where Learning is an integrated activity and
                  encourages children to link it with their everyday lives in
                  some way. <br />- Which promote thoughts that encourage
                  creative thinking. e Where learning builds capacity to create
                  new knowledge. <br />
                  - Where the "future" of the child should never take centre
                  stage against the child's "present".
                  <br />
                  <br /> I welcome you to SLV International School with best
                  wishes & good luck.
                  <br /> <br />
                  <b> Mr. Gopala Gowda M.</b> <br /> Founder Chairman
                </div>
              </Grid>
            </Grid>
          </div>
          <div className="aboutabout" style={{ marginTop: "50px" }}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
                <div
                  style={{
                    fontSize: "32px",
                    fontFamily: "Montserrat",
                    textAlign: "left",
                    color:
                      state.auth.theme == "dark"
                        ? themeStyleDark.primaryColor
                        : themeStyle.primaryColor,
                    fontWeight: "bold",
                  }}
                >
                  Message From Principal
                </div>
                <br />
                <div
                  style={{
                    fontSize: state.auth.isMobile ? "18px" : "22px",
                    fontFamily: "Montserrat",
                    textAlign: "justify",
                  }}
                >
                  At the SLV International School ,we believe in supporting
                  every individual to achieve his or her dreams, no matter how
                  big they may be. Our students are ambitious, inquisitive and
                  hardworking, ever embracing challenges and striving for their
                  best. We make out that all children have diverse abilities and
                  talents, and we are devoted to helping them discover and
                  develop these in a nurturing environment. Inclusion is an
                  important part of life at the SLV International School.
                  <br />
                  <br />
                  As Principal of SLV International School and as a parent
                  myself, I believe in raising children to be polite,
                  respectful, and responsible citizens, able to make a positive
                  contribution to society. Of equal importance is children’s
                  social and emotional development, enabling them to become
                  confident, assured, and happy. I believe in building a
                  community based on traditional values and mutual respect,
                  where students take pride in themselves, their work, and their
                  school, contributing fully on a daily basis to the benefit of
                  all.
                  <br />
                  <br /> If you are considering SLV International School for
                  your child, I warmly encourage you to visit us and experience
                  firsthand our unique environment and culture. We welcome
                  visitors throughout the year, so please don’t hesitate to get
                  in touch and make an appointment.
                  <br />
                  <br />
                  <b> Joby Varghese , Principal </b> <br />
                  MA (Eng), MA (Soc), BEd (Eng), MEd, BEd (Spl. Edu.)
                </div>
              </Grid>
              <Grid item xs={12} md={5}>
                <img
                  style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                  src={require("../img/princi.jpg")}
                />
              </Grid>
            </Grid>
            <div
              style={{
                marginTop: "50px",
                textAlign: "justify",
                fontSize: state.auth.isMobile ? "18px" : "22px",
              }}
            >
              We prepare our students to achieve excellent examination results
              and, at the same time, develop into well-rounded young adults who
              have the skills, attributes, and moral fibre to lead successful
              lives. We believe that an education should stretch young people
              academically and also develop them socially, all the while
              supporting them emotionally and ensuring their health, safety, and
              happiness.
              <br />
              <br />
              We provide a quality academic education based on the rigorous
              National Curriculum of our country with an international flavour.
              Our curriculum is designed to be broad and balanced to keep
              opportunities open while giving excellent preparation for further
              study. Being one of the leading schools, we pride ourselves on
              delivering a values-driven, high-standard education, expressed
              through four core values: leading through innovation, pursuing
              excellence, growing by learning, and global citizenship. These are
              woven into each of our academic and extracurricular activities and
              form the basis of everything we do. Accordingly, through our
              formal and informal curriculum, we encourage creative and critical
              thinking alongside stimulating and meaningful experiences.
              Integrated into our learning is the development of a range of key
              skills, attributes, and attitudes that we know will serve our
              students well in their later lives. The development of leadership
              skills is an important part of our curriculum, and all students
              have the chance to be involved in school leadership activities. We
              firmly believe in developing our students into global citizens who
              can excel on the world stage. We aim to develop a tolerant school
              community, reflecting the heritage of our students and recognizing
              that we all come from different backgrounds.
              <br />
              <br />{" "}
            </div>
          </div>
          <Benchmark />
          <div className="news">
            <div
              style={{
                textAlign: "justify",
                marginBottom: "50px",
                marginTop: "50px",
                fontSize: state.auth.isMobile ? "30px" : "30px",
                fontWeight: "bold",
                fontFamily: "Montserrat",
                color:
                  state.auth.theme == "dark"
                    ? themeStyleDark.primaryColor
                    : themeStyle.primaryColor,
              }}
            >
              A Glimpse of the Campus
            </div>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/vday.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Vegetables day
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/pooja.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Pooja
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/kg.jpg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Kindergarten
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/pg.jpg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Playground
                  </div>
                </div>
              </Grid>
            </Grid>
            <br />
            <br />
            <Grid
              container
              spacing={2.5}
              style={{ justifyContent: "center", paddingBottom: "100px" }}
            >
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/entrance.jpg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    School Entrance
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/redday.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Red day
                  </div>
                </div>
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={3} xl={3}>
                <div className="icard">
                  <img
                    src={require("../img/krshna.jpeg")}
                    alt="Norway"
                    style={{
                      width: "300px",
                      height: "250px",
                      borderRadius: "10px",
                      objectFit: "contain",
                    }}
                  />
                  <div
                    style={{
                      padding: "0px 10px 0px 10px",
                      fontSize: "20px",
                      color:
                        state.auth.theme == "dark"
                          ? themeStyleDark.primaryColor
                          : themeStyle.primaryColor,
                      fontFamily: "Montserrat",
                      textAlign: "justify",
                      fontWeight: 600,
                    }}
                  >
                    Gokulashtami
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <Explore />
          <VisitUs />
          <Footer />
        </div>
      );
    }
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: transition ? 1 : 0,
      }}
    >
      {getContent()}
    </div>
  );
}
